<template>
  <div>
    <preamble v-bind="preamble" />
    <section class="main">
        <div class="container">
            <div class="columns">
                <div class="column is-8 is-offset-2">
                    <div v-if="icons < 1" class="column is-12">
                        <div class="chapter">
                            <div>
                                <h3>Loading...</h3>
                            </div>
                        </div>
                    </div>
                    <div v-for="icon in icons" :key="icon.id" class="columns legacy mb-6">
                        <div class="column is-4">
                            <div class="chapter bg-black icon-page">
                                <div>
                                    <img v-bind:src="icon.image" v-bind:alt="icon.title" class="rounded">
                                </div>
                            </div>
                        </div>
                        <div class="column is-8">
                            <div>
                                <h2>
                                    {{ icon.title}}
                                </h2>
                                <div v-html="icon.shortDescription"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
    import Preamble from '@/components/Preamble.vue'
    import sharedMethodsMixin from '@/mixins/sharedMethodsMixin'
    import { resources, API } from '@/utils/constants'

    export default {
        name: "Icons",
        mixins: [sharedMethodsMixin],
        components: {
                Preamble    
                },
        data() {
            return {
              // triggered: true,
              icons: [],
              preamble: {
                title: 'Icons and Collaborators',
                subTitle: 'Left us a legacy',
                description: '<p>Since the early days of the HIV epidemic, communication was recognised as a key tool in the fight against the disease. Globally, cultural sensitivities around HIV transmission meant that few people were willing to speak about its causes or effects publicly, and the resulting lack of knowledge contributed to the spread of the illness. A small group of unique individuals in Uganda fought hard to break this silence, and their contribution to the struggle was vital.  At a time when the disease was killing thousands weekly, the leadership of these doctors, activists, academics, politicians and public figures made it possible to slow the spread of the infection. Through clear and unambiguous speech they encouraged people to discuss HIV, get tested and use prophylaxis, as well as dispelling rumours and puncturing falsehoods. In that era of stigma and silence their candour and bravery often came at a personal cost, and we salute their contribution to the fight. </p>',
                watchVideo: '',

              },
            }
        },
        created() {

          this.read(`${resources.icons}`)
            .then(response => {
              this.icons = response.data.map(icon => {
                icon = {
                  id: icon.id,
                  title: icon.title,
                  shortDescription: icon.shortDescription,
                  image: `${API}${icon.image}`
                }
                return icon
              })
          })
        
        },
        mounted() {
            
        },
        methods: {
          
        },
        computed: {
             
        },
    }
</script>

<style>
</style>
